import { setToken, removeToken } from '@/utils/auth'


const state = {
  token: null
}


const mutations = {
  SET_TOKEN: (state, token) => { 
    state.token = token
  }
}

const actions = {
  saveToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token)
      setToken(token)
      resolve()
    })
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js